import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {AutoCompleteModule, CalendarModule, CardModule, CheckboxModule, GrowlModule} from 'primeng/primeng';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ProgressBarModule} from 'primeng/progressbar';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from '@ngx-translate/core';
import {RDSendReportComponent} from './rd-send-report.component';
import { ClickOutsideModule } from 'ng-click-outside';
 
@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    GrowlModule,
    NgbModule,
    CoreModule,
    TableModule,
    TranslateModule,
    ProgressBarModule,
    CardModule,
    ClickOutsideModule
  ],
  declarations: [RDSendReportComponent]
})
export class RDSendReportModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/rd-send-report/rd-send-report.module.ts